import script from "./invalid.vue?vue&type=script&lang=ts&setup=true"
export * from "./invalid.vue?vue&type=script&lang=ts&setup=true"

import "./invalid.vue?vue&type=style&index=0&id=675a2f96&lang=scss"

const __exports__ = script;

export default __exports__